/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const BookingSuccessBanner = ({ show, totalOccurrences, onClose }) => {
  if (!show) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      className="mb-8 bg-emerald-50 border border-emerald-200 rounded-2xl p-6 shadow-lg"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
          <CheckCircle className="w-5 h-5 text-emerald-600" />
        </div>
        <div>
          <h3 className="font-semibold text-emerald-800">Booking Confirmed!</h3>
          <p className="text-sm text-emerald-700">
            Your {totalOccurrences} {totalOccurrences === 1 ? 'session' : 'sessions'} have been successfully scheduled.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default BookingSuccessBanner;